/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home',
      icon: 'mdi:monitor-dashboard',
      order: 1,
      constant: false
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      constant: true,
      hideInMenu: true,
      keepAlive: true
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'post',
    path: '/post',
    component: 'layout.base',
    meta: {
      title: 'post',
      i18nKey: 'route.post',
      order: 2
    },
    children: [
      {
        name: 'post_form',
        path: '/post/form',
        meta: {
          title: 'post_form',
          i18nKey: 'route.post_form',
          hideInMenu: true
        },
        children: [
          {
            name: 'post_form_photo',
            path: '/post/form/photo',
            meta: {
              title: 'post_form_photo',
              i18nKey: 'route.post_form_photo'
            },
            children: [
              {
                name: 'post_form_photo_add',
                path: '/post/form/photo/add',
                component: 'view.post_form_photo_add',
                meta: {
                  title: 'post_form_photo_add',
                  i18nKey: 'route.post_form_photo_add'
                }
              },
              {
                name: 'post_form_photo_edit',
                path: '/post/form/photo/edit/:id',
                component: 'view.post_form_photo_edit',
                meta: {
                  title: 'post_form_photo_edit',
                  i18nKey: 'route.post_form_photo_edit'
                }
              }
            ]
          }
        ]
      },
      {
        name: 'post_photo',
        path: '/post/photo',
        component: 'view.post_photo',
        meta: {
          title: 'post_photo',
          i18nKey: 'route.post_photo'
        }
      }
    ]
  },
  {
    name: 'resources',
    path: '/resources',
    component: 'layout.base$view.resources',
    meta: {
      title: 'resources',
      i18nKey: 'route.resources',
      order: 3
    }
  },
  {
    name: 'system',
    path: '/system',
    component: 'layout.base',
    meta: {
      title: 'system',
      i18nKey: 'route.system',
      order: 4,
      hideInMenu: false
    },
    children: [
      {
        name: 'system_config',
        path: '/system/config',
        meta: {
          title: 'system_config',
          i18nKey: 'route.system_config'
        },
        children: [
          {
            name: 'system_config_category',
            path: '/system/config/category',
            component: 'view.system_config_category',
            meta: {
              title: 'system_config_category',
              i18nKey: 'route.system_config_category'
            },
            children: [
              {
                name: 'system_config_category_add',
                path: '/system/config/category/add',
                component: 'view.system_config_category_add',
                meta: {
                  title: 'system_config_category_add',
                  i18nKey: 'route.system_config_category_add'
                }
              },
              {
                name: 'system_config_category_edit',
                path: '/system/config/category/edit/:id',
                component: 'view.system_config_category_edit',
                meta: {
                  title: 'system_config_category_edit',
                  i18nKey: 'route.system_config_category_edit'
                }
              }
            ]
          },
          {
            name: 'system_config_item',
            path: '/system/config/item',
            meta: {
              title: 'system_config_item',
              i18nKey: 'route.system_config_item'
            },
            children: [
              {
                name: 'system_config_item_add',
                path: '/system/config/item/add',
                component: 'view.system_config_item_add',
                meta: {
                  title: 'system_config_item_add',
                  i18nKey: 'route.system_config_item_add'
                }
              },
              {
                name: 'system_config_item_edit',
                path: '/system/config/item/edit/:id',
                component: 'view.system_config_item_edit',
                meta: {
                  title: 'system_config_item_edit',
                  i18nKey: 'route.system_config_item_edit'
                }
              }
            ]
          },
          {
            name: 'system_config_list',
            path: '/system/config/list',
            component: 'view.system_config_list',
            meta: {
              title: 'system_config_list',
              i18nKey: 'route.system_config_list'
            }
          }
        ]
      },
      {
        name: 'system_db',
        path: '/system/db',
        component: 'view.system_db',
        meta: {
          title: 'system_db',
          i18nKey: 'route.system_db'
        }
      }
    ]
  }
];
